 

const state = {
 
	bgSetting: true,
	userdata:null
}

export default state